export default __webpack_public_path__ + "static/featured_image_og_codilime_blog-39cee824784b0938286aa6a80cad14dd.jpg";